import axios from "axios";
import { apiAxiomLog } from "./logging";

export const apiGetVotingOnlyBoards = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/boards/voting-only?client=${client}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api boards apiGetVotingOnlyBoards");
    console.log(error);
    return null;
  }
};

export const apiGetVotingOnlyMembers = async (board) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/boards/voting-members?board=${board}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api boards apiGetVotingOnlyMembers");
    console.log(error);
    return null;
  }
};

export const apiGetAgendaGroupsForBoard = async (board) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/agendagroups/department/${board}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api boards apiGetAgendaGroupsForBoard");
    console.log(error);
    return null;
  }
};

export const apiUpdateAgendaGroup = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/agendagroups/update/${id}`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api boards apiGetAgendaGroupsForBoard");
    console.log(error);
    return null;
  }
};

export const apiRemoveAgendaGroup = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/agendagroups/remove/${id}`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api boards apiRemoveAgendaGroup");
    console.log(error);
    return null;
  }
};

export const apiReorderAgendaGroups = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/agendagroups/reorder`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api boards apiReorderAgendaGroups");
    console.log(error);
    return null;
  }
};

export const apiCreateAgendaGroup = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/agendagroups/create`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api boards apiCreateAgendaGroup");
    console.log(error);
    return null;
  }
};

export const apiGetAllBoards = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/boards/regular/${client}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api boards apiGetAllBoards");
    console.log(error);
    return null;
  }
};

export const apiGetClientBoards = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/boards/list/${client}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api boards apiGetAllBoards");
    console.log(error);
    return null;
  }
};

export const apiGetSingleBoard = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/boards/info/${id}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api boards apiGetSingleBoard");
    console.log(error);
    return null;
  }
};

export const apiUpdateBoard = async (id, data, client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/boards/info/${id}?client=${client}`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/boards apiUpdateBoard",
      params: { id: id, data: data },
      error: error.toString(),
    });
    return null;
  }
};

export const apiDuplicateBoard = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/boards/duplicate`,
        { board: id },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/boards apiDuplicateBoard",
      params: req.body,
      error: error.toString(),
    });
    return null;
  }
};

export const apiUpdateStandingProxy = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/members/proxy/${id}`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/boards apiUpdateBoard",
      params: { id: id, data: data },
      error: error.toString(),
    });
    return null;
  }
};

export const apiUpdateAgendaOptions = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/boards/options/${id}`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/boards apiUpdateAgendaOptions",
      params: { id: id, data: data },
      error: error.toString(),
    });
    return null;
  }
};
